/**
 * Formats a date string into a human readable format
 * @param dateString Date string to format
 * @returns Formatted date string
 */
export const formatDateTime = (date: string | Date | null): string => {
  if (!date) return "N/A";
  return new Date(date).toLocaleString();
};

/**
 * Formats minutes into a human readable duration string
 * @param minutes Number of minutes to format
 * @returns Formatted duration string (e.g. "2 hrs 30 mins" or "45 mins")
 */
export const formatHosTime = (minutes: number): string => {
  if (minutes === 0) return "0 min";

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours === 0) return `${remainingMinutes} min`;
  if (remainingMinutes === 0) return `${hours} h`;

  return `${hours} h ${remainingMinutes} min`;
};

export const formatTableTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}`;
};
